export class CompanyParams {
  public static colors: string[] = [
    '#ED5565',
    '#FC6E51',
    '#FFCE54',
    '#44CFAD',
    '#4FC1E9',
    '#AC92EC',
    '#EC87C0',
    '#A08053',
  ];
  public static hasAccessToMat = false;

  static clear() {
    this.colors = [
      '#ED5565',
      '#FC6E51',
      '#FFCE54',
      '#44CFAD',
      '#4FC1E9',
      '#AC92EC',
      '#EC87C0',
      '#A08053',
    ];
    this.hasAccessToMat = false;
  }
}
